
import { Component, OnInit } from '@angular/core';
import { MainService as mainServiceMd } from '../../../md/service/main.service';

//  import {session} from '../../../../../environments/environment.session'
  @Component({
    selector: 'app-work-flow',
    templateUrl: './work-flow.component.html',
    styleUrls: ['./work-flow.component.css']
})
export class WorkFlowComponent implements OnInit {

  constructor(private mainServiceMd:mainServiceMd) { }

  ngOnInit() {
    this.mainServiceMd.selectedModuleForCommonWorkFlow='NOC'
  }

}


